import { useEffect } from 'react';
import { Experience, ContactCTA } from '@ui/sections';
import { experience } from '@content/experience';
import { site } from '@content/site';
import { experienceCopy, contactCtaCopy } from '@content/ui-strings';

export function ExperienceRoute() {
  useEffect(() => {
    document.title = `Experience · ${site.seo.title.split(' · ')[0] ?? 'Alison Haire'}`;
  }, []);

  return (
    <>
      <Experience
        experience={experience}
        linkedinHref={site.links['linkedin'] ?? '#'}
        arxivHref={site.links['arxiv'] ?? '#'}
        copy={experienceCopy}
      />
      <ContactCTA calendlyHref={site.links['calendly'] ?? '#'} copy={contactCtaCopy} />
    </>
  );
}
